import React, { type ReactNode } from 'react'
import * as SelectPrimitive from '@radix-ui/react-select'
import clsx from 'clsx'

import { ReactComponent as ArrowUpSvg } from '../assets/svgs/arrow-up.svg'

type SelectProps = SelectPrimitive.SelectProps & {
  children: ReactNode
  defaultValue: string
}

const Select = ({ children, ...props }: SelectProps) => (
  <SelectPrimitive.Root {...props}>
    <SelectPrimitive.Trigger className="whitespace-nowrap px-4 py-1 border border-grey-500 min-w-[199px] rounded-lg inline-flex items-center justify-between leading-none h-8 bg-white text-sm text-grey-700 font-medium outline-none data-[state='open']:border-secondary-dark">
      <SelectPrimitive.Value placeholder="10 itens por página" />
      <SelectPrimitive.Icon>
        <ArrowUpSvg />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>

    <SelectPrimitive.Portal className="z-50">
      <SelectPrimitive.Content
        side="bottom"
        position="popper"
        align="start"
        className="w-full py-2 my-1 overflow-hidden bg-white border rounded-md border-grey-500"
      >
        <SelectPrimitive.Viewport>
          <SelectPrimitive.Group className="w-full">
            {children}
          </SelectPrimitive.Group>
        </SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  </SelectPrimitive.Root>
)

// eslint-disable-next-line react/display-name
export const SelectItem = React.forwardRef(
  ({ children, className, ...props }: any, forwardedRef) => {
    return (
      <SelectPrimitive.Item
        className={clsx(
          'h-10 w-full px-4 cursor-pointer flex items-center  data-[state="checked"]:bg-secondary-dark data-[state="checked"]:text-white data-[state="checked"]:font-semibold font-medium text-base outline-none text-grey-700',
          className
        )}
        {...props}
        ref={forwardedRef}
      >
        <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
      </SelectPrimitive.Item>
    )
  }
)

export default Select
